import { useContext } from 'react';
import {
  AccountSalaryKeyContext,
  type AccountSalaryKeyContextValue,
} from '@/contexts/AccountSalaryKeyContext';

export function useAccountSalaryKey(): AccountSalaryKeyContextValue {
  const ctx = useContext(AccountSalaryKeyContext);
  if (!ctx) {
    throw new Error('useAccountSalaryKey must be used within an AccountSalaryKeyProvider');
  }
  return ctx;
}
